/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ai-mate.agent-header-banner-label': 'Banner de agente',
  'ai-mate.agent-list.all-agents-section-title': 'Todos os agentes',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Você alterou o proprietário de {agentName} para {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Proprietário alterado',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Tem certeza de que quer excluir este agente? A ação não pode ser desfeita.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Excluir "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': 'Não foi possível excluir o agente',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Algo deu errado ao excluir o agente. Tente de novo em alguns instantes.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Falha ao excluir o agente',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'O agente está em uso no momento. Tente de novo mais tarde.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Não foi possível encontrar esse agente.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Você não pode excluir agentes que você mesmo não tenha criado. Entre em contato com o proprietário do agente.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Você excluiu {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agente excluído',
  'ai-mate.agent-list.development-section-title': 'Agentes de desenvolvimento',
  'ai-mate.agent-list.load-more-button-loading': 'Carregando mais agentes...',
  'ai-mate.agent-list.load-more-button-ready': 'Carregar mais',
  'ai-mate.agent-list.loading-agents': 'Carregando agentes...',
  'ai-mate.agent-list.no-results': 'Nenhum resultado encontrado para "{searchValue}"',
  'ai-mate.agent-list.recommended-agents-section-title': 'Recomendado',
  'ai-mate.agent-list.searching-agents': 'Procurando agentes...',
  'ai-mate.agent-list.templates-description':
    'Use estes templates para criar o seu próprio agente de desenvolvimento. Escolha o template de agente correto para o seu ticket, selecione Usar template e preencha o prompt do template com informações específicas, como repositório, pasta, idioma e biblioteca. Crie agentes de desenvolvimento personalizados para codificar diferentes tarefas, projetos ou repositórios.',
  'ai-mate.agent-list.templates-lozenge-title': 'Template',
  'ai-mate.agent-list.templates-title': 'Templates de codificação',
  'ai-mate.agent-message.agent-not-found': 'Agente não encontrado',
  'ai-mate.agent-message.convo-title': 'Converse com {agentName} acionado a partir da integração de link inteligente',
  'ai-mate.agent-message.copy-link': 'Copie o link do agente',
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Escreva uma mensagem para {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Enviar',
  'ai-mate.agent-message.view-profile': 'Visualizar perfil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Cancelar',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Excluir',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agente · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Converse com {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL copiada',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Copiar link',
  'ai-mate.agent-profile-info.hidden-icon': 'Oculto',
  'ai-mate.agent-profile-info.hidden-tooltip': 'O agente não vai aparecer nos resultados da pesquisa',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Marcar agente com estrela',
  'ai-mate.agent-selector.agent-not-found': 'Agente não encontrado',
  'ai-mate.agent-selector.default-agent-description':
    'Obtenha respostas, gere novas ideias e acelere o trabalho diário.',
  'ai-mate.agent-selector.default-agent-name': 'Bate-papo',
  'ai-mate.browse-agents-view.close-button': 'Fechar visualização dos agentes',
  'ai-mate.browse-agents.scenario-pill.default-scenario-tag': 'Padrão',
  'ai-mate.browse-agents.scenario-pill.inactive-scenario-tooltip': 'Inativos',
  'ai-mate.profile-card-preview.actions-title': 'Ações',
  'ai-mate.profile-card-preview.agent-default-title': 'Agente',
  'ai-mate.profile-card-preview.agent-description-label': 'Descrição',
  'ai-mate.profile-card-preview.agent-title-label': 'Título',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Iniciadores de conversa',
  'ai-mate.profile-card-preview.empty-actions': 'Nenhum',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Nenhum',
  'ai-mate.profile-card-preview.empty-instructions': 'Nenhum',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Nenhum selecionado',
  'ai-mate.profile-card-preview.instructions-title': 'Instruções',
  'ai-mate.profile-card-preview.knowledge-title': 'Conhecimento',
  'ai-mate.profile-card-preview.regenerate-label': 'Gerar {fieldName} de novo',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - Copiar',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Arraste para reordenar',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Não foi possível salvar as alterações',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Ocorreu um erro desconhecido. Tente de novo',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Um agente com esse nome já existe',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Remover',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Gerar iniciadores de conversa',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} não pode ter mais de {maxLength,number} caractere} other {{fieldName} não pode ter mais de {maxLength,number} caracteres}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Avançar',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Reiniciar',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Pular para a configuração manual',
  'create-agent.owner-field.confirm-modal-cancel': 'Cancelar',
  'create-agent.owner-field.confirm-modal-confirm': 'Sim, continuar',
  'create-agent.owner-field.confirm-modal-content':
    'Você vai mudar o proprietário deste agente para {name}. Ao fazer isso, você não vai mais poder editar ou gerenciar esse agente.',
  'create-agent.owner-field.confirm-modal-title': 'Você vai perder o acesso de edição',
  'create-agent.owner-field.owner-description': 'Essa é a pessoa que pode editar ou gerenciar o agente.',
  'create-agent.owner-field.owner-label': 'Proprietário',
  'rovo-chat.agent-card.deactivated-name': '{name} (desativado)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Muitas solicitações. Espere um momento.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Tentar de novo',
  'rovo-chat.browse-agents.all-agents-button': 'Todos',
  'rovo-chat.browse-agents.close-button': 'Fechar',
  'rovo-chat.browse-agents.create-agent-button': 'Criar',
  'rovo-chat.browse-agents.create-an-agent-button': 'Criar agente',
  'rovo-chat.browse-agents.create-button-disabled-tooltip': 'Você não tem permissão para criar agentes neste site',
  'rovo-chat.browse-agents.created-by-label': '<text>por</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Agentes de programação',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favoritos',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agente marcado como favorito',
  'rovo-chat.browse-agents.modal-title': 'Pesquisar agentes',
  'rovo-chat.browse-agents.my-agents-button': 'Agentes que criei',
  'rovo-chat.browse-agents.no-created-agents':
    'Parece que você ainda não criou um agente. Você pode duplicar agentes criados por outras pessoas ou começar um do zero.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Nenhum agente criado ainda',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': 'Você não criou nenhum agente',
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    'Você precisa da permissão de um administrador para criar agentes Rovo neste site.',
  'rovo-chat.browse-agents.no-starred-agents':
    'Marque os agentes de que você mais gosta ou usa com mais frequência para facilitar o acesso a eles.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Você ainda não marcou com estrela nenhum agente',
  'rovo-chat.browse-agents.search-input.placeholder': 'Pesquisar agentes',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Pesquisar templates',
  'rovo-chat.browse-agents.see-all-agents-button': 'Ver todos os agentes',
  'rovo-chat.browse-agents.templates-button': 'Templates',
  'rovo-chat.create-agent.actions-section-description':
    'Adicione ações para que o agente faça tarefas no Jira, Confluence e Jira Service Management. <link>o que são ações de agentes?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Adicionar ações',
  'rovo-chat.create-agent.all-content-label': 'Todo o conteúdo',
  'rovo-chat.create-agent.back-button': 'Voltar',
  'rovo-chat.create-agent.beta-lozenge': 'Beta',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Você ainda não criou um agente. Quer que seja descartado?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Cancelar',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Sim, descarte o agente',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Agente inacabado',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Tem certeza de que quer descartar as alterações feitas neste agente?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Confirmar',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Reiniciar sua criação',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'As pessoas podem usar esses iniciadores de conversa para começar um bate-papo com o agente. Se você não lembrar de nenhum, a gente pode gerar alguns para você.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Iniciadores de conversa',
  'rovo-chat.create-agent.create-agent-button': 'Criar',
  'rovo-chat.create-agent.ctions-section-title': 'Ações',
  'rovo-chat.create-agent.description-field-description':
    'As pessoas podem usar a descrição no perfil do agente para saber mais sobre o assunto.',
  'rovo-chat.create-agent.description-field-label': 'Descrição',
  'rovo-chat.create-agent.description-field-placeholder':
    'Escreva uma breve descrição sobre o agente (por exemplo, redator criativo para blogs de marketing)',
  'rovo-chat.create-agent.instructions-field-description':
    'Como você quer que esse agente se comporte? O que ele pode fazer? <link>Saiba mais sobre como escrever instruções para um agente</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instruções',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Personalize as instruções para este agente',
  'rovo-chat.create-agent.intro-description-part-1':
    'Crie um agente com conhecimento especializado para responder perguntas, escrever e revisar conteúdo e fazer tarefas para ajudar você a avançar no trabalho.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Se não precisar de ajuda para criar o agente, você pode <bold>pular para a configuração manual</bold>.',
  'rovo-chat.create-agent.intro-description-part-3':
    'Se precisar, permaneça nesta página e a gente pode criar um juntos.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Vou criar instruções para o agente com base no que você escrever. Apenas me diga para que você planeja usar o agente.',
  'rovo-chat.create-agent.intro-step-1-title': 'Descreva o que você quer que seu agente faça',
  'rovo-chat.create-agent.intro-step-2-content':
    'Hora de decidir o nome e a personalidade do seu agente. Diga se seu agente é empático, direto ou engraçado.',
  'rovo-chat.create-agent.intro-step-2-title': 'Adicione personalidade',
  'rovo-chat.create-agent.intro-step-3-content':
    'Selecione <bold>Avançar</bold> para verificar seu novo agente, adicionar ações, conhecimento e uma foto de perfil. Quando terminar, selecione <bold>Criar</bold>.',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    'Clique em <bold>Avançar</bold> para avaliar o novo agente, adicionar competências, conhecimentos e uma foto de perfil. Quando terminar, selecione <bold>Criar</bold>.',
  'rovo-chat.create-agent.intro-step-3-title': 'Revise e crie seu agente',
  'rovo-chat.create-agent.intro-title': '👋 É hora de criar seu agente',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Todos os projetos',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'Todos os espaços',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.jsm-filter-knowledge-base-placeholder': 'Pesquisar base de conhecimento',
  'rovo-chat.create-agent.knowledge-field-description':
    'Especifique o conhecimento do agente permitindo que ele consulte apenas as fontes que você informar',
  'rovo-chat.create-agent.knowledge-field-label': 'Conhecimento',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Consultar apenas estas fontes',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Links',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Sugerido',
  'rovo-chat.create-agent.manage-actions-button-label': 'Gerenciar ações',
  'rovo-chat.create-agent.name-field-description': 'As pessoas podem usar essa opção para localizar o agente.',
  'rovo-chat.create-agent.name-field-label': 'Nome',
  'rovo-chat.create-agent.name-field-placeholder': 'Nomeie seu agente',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': 'Ocorreu um erro inesperado. Tente de novo.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Olá! Estou aqui para ajudar você a criar um agente personalizado. O que você quer que o agente faça?',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Criar agente',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Escreva uma mensagem',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Enviar',
  'rovo-chat.create-agent.page-title': 'Criar agente',
  'rovo-chat.create-agent.page-title-edit': 'Editar agente',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Pesquisar páginas',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Pesquisar espaços',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Todos',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Cancelar',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Fechar',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Selecionar menos de {count,number} ação é ideal para o desempenho} other {Selecionar menos de {count,number} ações é ideal para o desempenho}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Salvar',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Pesquisar ações',
  'rovo-chat.create-agent.select-action-modal-title': 'Adicionar ações',
  'rovo-chat.create-agent.select-content-under-label': 'Selecione o conteúdo em',
  'rovo-chat.create-agent.select-spaces-label': 'Selecione espaços',
  'rovo-chat.create-agent.selected-actions-label': 'Ações selecionadas:',
  'rovo-chat.create-agent.unknown-owner': 'Desconhecido',
  'rovo-chat.create-agent.update-agent-button': 'Atualizar',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Se você continuar, vai perder todas as alterações que não foram salvas. Selecione Cancelar para continuar editando o agente.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Continuar e descartar as alterações',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Descartar alterações',
  'rovo-chat.view-agent.about-label': 'Sobre',
  'rovo-chat.view-agent.actions-label': 'Ações',
  'rovo-chat.view-agent.agent-instructions.copy-label': 'Copiar',
  'rovo-chat.view-agent.agent-instructions.copy-tooltip': 'Instruções de cópia',
  'rovo-chat.view-agent.agent-instructions.placeholder': 'Esse agente não tem instruções personalizadas',
  'rovo-chat.view-agent.all-knowledge-added': 'Todo o conhecimento organizacional',
  'rovo-chat.view-agent.behaviour-label': 'Comportamento',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Bate-papo com agente',
  'rovo-chat.view-agent.close-button': 'Fechar',
  'rovo-chat.view-agent.copied-instructions-tooltip-label': 'Copiado',
  'rovo-chat.view-agent.copy-instructions-tooltip-label': 'Copiar',
  'rovo-chat.view-agent.created-by-label': '<text>por</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Nº de favoritos',
  'rovo-chat.view-agent.go-back-label': 'Voltar',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Os agentes do Forge criados com código têm as instruções ocultas por motivos de privacidade.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Estas instruções são privadas',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Agentes do Forge criados com código não usam fontes de conhecimento típicas',
  'rovo-chat.view-agent.inactive-action-tooltip': 'Inativos',
  'rovo-chat.view-agent.instructions-label': 'Instruções',
  'rovo-chat.view-agent.knowledge-label': 'Conhecimento',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} membro} other {{count,number} membros}}',
  'rovo-chat.view-agent.modal-title': 'Pesquisar agentes',
  'rovo-chat.view-agent.no-actions': 'Nenhuma ação',
  'rovo-chat.view-agent.no-behaviour-placeholder': 'Esse agente não tem comportamento personalizado',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Esse agente não tem instruções personalizadas',
  'rovo-chat.view-agent.no-knowledge-added': 'Nenhum conhecimento organizacional',
  'rovo-chat.view-agent.no-scenarios': 'Nenhum cenário',
  'rovo-chat.view-agent.no-skills': 'Nenhuma competência',
  'rovo-chat.view-agent.no-teams': 'Não faz parte de nenhuma equipe',
  'rovo-chat.view-agent.open-chat-label': 'Para começar a conversa',
  'rovo-chat.view-agent.reactions-metadata-label': 'Nº de reações',
  'rovo-chat.view-agent.rovo-agent-label': 'Agente Rovo',
  'rovo-chat.view-agent.scenarios-label': 'Cenários',
  'rovo-chat.view-agent.skills-label': 'Competências',
  'rovo-chat.view-agent.teams-label': 'Equipes',
  'rovo-chat.view-agent.users-metadata-label': 'Nº de usuários',
  'rovo.agent.scenarios.scenarioModal.actionsLabel': 'Ações',
  'rovo.agent.scenarios.scenarioModal.instructionsLabel': 'Instruções',
  'rovo.agent.scenarios.scenarioModal.knowledgeSourcesLabel': 'Conhecimento',
  'rovo.agent.scenarios.scenarioModal.mcpServersLabel': 'Servidores MCP',
  'rovo.agent.scenarios.scenarioModal.noActions': 'Nenhuma ação',
  'rovo.agent.scenarios.scenarioModal.noInstructions': 'Nenhuma instrução',
  'rovo.agent.scenarios.scenarioModal.noMcpServers': 'Nenhum servidor MCP',
  'rovo.agent.scenarios.scenarioModal.noSkills': 'Nenhuma competência',
  'rovo.agent.scenarios.scenarioModal.skillsLabel': 'Competências',
  'rovo.conversation.assistant.agent.deepResearchPill': 'Pesquisa avançada',
};
